<template>
  <div>
    <div class="elevation-2 pt-7 pb-4 px-7">
      <v-card outlined v-if="survey" class="mb-2">
        <v-card-text class="text-center">
          <p class="text-right">mod. SER/TMS</p>
          <h5 class="text-h5 text-center">Istituto Nazionale di Statistica</h5>
          <p class="text-subtitle-1 text-center">Direzione Centrale delle Statistiche Ambientali e Territoriali</p>
          <p class="text-subtitle-1 text-center">Servizio Reti Territoriali e Ambientali</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="text-center py-1 text-subtitle-1 font-italic">
          <strong>Rilevazione sul Trasporto merci su strada</strong>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-1">
          <v-row no-gutters>
            <v-col cols="3">Provincia immatricolazione</v-col>
            <v-col cols="3" class="mono">{{ survey.vehicle_province }}</v-col>
            <v-col cols="1">Targa</v-col>
            <v-col cols="3" class="mono">{{ survey.vehicle_targa }}</v-col>
            <v-col cols="3">Settimana di rilevazione dal</v-col>
            <v-col cols="3" class="mono">{{ survey.start_date }}</v-col>
            <v-col cols="1">al</v-col>
            <v-col cols="3" class="mono">{{ survey.end_date }}</v-col>
            <v-col cols="2"></v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="py-1">
          <p class="mb-1"><strong>IMPRESA</strong> <i></i></p>
          <v-row no-gutters>
            <v-col cols="2">Ragione sociale</v-col>
            <v-col cols="10" class="mono">{{ survey.company.name }}</v-col>
            <v-col cols="2">Indirizzo</v-col>
            <v-col cols="10" class="mono">{{ survey.company.address }}</v-col>
            <v-col cols="2">Città</v-col>
            <v-col cols="4" class="mono">{{ survey.company.city.full_name }}</v-col>
            <v-col cols="1">CAP</v-col>
            <v-col cols="2" class="mono">{{ survey.company.zip }}</v-col>
            <v-col cols="1">ATECO</v-col>
            <v-col cols="2" class="mono">{{ survey.company.ateco.code }}</v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-1">
          <p class="mb-1"><strong>REFERENTE</strong> <i>Persona da contattare per eventuali chiarimenti</i></p>
          <v-row no-gutters>
            <v-col cols="2">Nominativo</v-col>
            <v-col cols="10" class="mono">{{ survey.referent.name }}</v-col>
            <v-col cols="2">Telefono</v-col>
            <v-col cols="4" class="mono">{{ survey.referent.phone }}</v-col>
            <v-col cols="1">Email</v-col>
            <v-col cols="4" class="mono">{{ survey.referent.email }}</v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined v-if="survey" class="mb-2">
        <v-card-text class="pb-0 pt-1">
          <p class="mb-1"><strong>ATTIVITA'</strong> <i>Informazioni sull'attività dell'automezzo</i></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-1">
          <v-row no-gutters>
            <v-col cols="4">
              <p class="mb-0"><strong>KM PERCORSI</strong></p>
              <p><i>nella settimana di riferimento</i></p>
              <v-row no-gutters>
                <v-col cols="6">Con carico</v-col>
                <v-col cols="6" class="mono text-right">{{ totalLoadedDistance }} km</v-col>
                <v-col cols="6">A vuovo</v-col>
                <v-col cols="6" class="mono text-right">{{ totalEmptyDistance }} km</v-col>
              </v-row>
              <p class="mb-0 mt-5"><strong>CARBURANTE CONSUMATO</strong></p>
              <p><i>nella settimana di riferimento</i></p>
              <v-row no-gutters>
                <v-col class="mono text-left">{{ survey.vehicle_fuel_consumed }} l</v-col>
              </v-row>
            </v-col>
            <v-col cols="8" class="pl-10">
              <p class="mb-0">
                <strong>PUNTI DI FRONTIERA</strong>
              </p>
              <p class="mt-0">
                <i>
                  terrestri attraversati, in entrata o in uscita dall'Italia, nella settimana di riferimento (solo in
                  caso di viaggi internazionali)
                </i>
              </p>
              <v-row no-gutters>
                <v-col class="mono text-left">
                  <div v-for="(border, index) in crossedBorders" :key="index">
                    {{ border }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined v-if="survey" color="mb-2">
        <v-card-text class="pb-0 pt-1">
          <p class="mb-1"><strong>PROPRIETA' AUTOMEZZO</strong> <i></i></p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="py-1">
          <v-row no-gutters>
            <v-col cols="4">
              1. venduto in data
              <span class="mono">{{ survey.ownership.reason === 1 ? survey.ownership.date : '' }}</span>
            </v-col>
            <v-col cols="4">
              2. ceduto in data
              <span class="mono">{{ survey.ownership.reason === 2 ? survey.ownership.date : '' }}</span>
            </v-col>
            <v-col cols="4">
              3. locato in data
              <span class="mono">{{ survey.ownership.reason === 3 ? survey.ownership.date : '' }}</span>
            </v-col>
            <v-col cols="4">
              4. rottamato in data
              <span class="mono">{{ survey.ownership.reason === 4 ? survey.ownership.date : '' }}</span>
            </v-col>
            <v-col cols="4">
              5. sequestrato in data
              <span class="mono">{{ survey.ownership.reason === 5 ? survey.ownership.date : '' }}</span>
            </v-col>
            <v-col cols="4">
              6. rubato in data
              <span class="mono">{{ survey.ownership.reason === 6 ? survey.ownership.date : '' }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined v-if="survey" color="mb-2">
        <v-card-text class="pb-0 pt-1">
          <p class="mb-1"><strong>PARCO AUTOMEZZI</strong> al 01/01/{{ survey.year }}<i></i></p>
        </v-card-text>
        <v-divider></v-divider>

        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" width="50%"></th>
                <th class="text-center">Proprietà</th>
                <th class="text-center">Leasing</th>
                <th class="text-center">Locazione</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in ['vehicles', 'tractors', 'trailers', 'semitrailers']" :key="item.name">
                <td>{{ fleetNames[item] }}</td>
                <td v-for="counter in ['owned', 'leasing', 'rent']" :key="counter" class="text-center">
                  {{ survey.fleet[item][counter] }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <v-card outlined v-if="survey" class="mb-2">
        <v-card-text class="text-center py-1">
          PER INFORMAZIONI E CHIARIMENTI CHIAMARE <br />IL NUMERO VERDE (GRATUITO) <strong>800.943.093</strong><br />ORE
          9-12 E 15-18, DAL LUNEDI' AL VENERDI'
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    survey: {
      type: Object,
      required: true,
    },
    distances: {
      type: Object,
      default: () => ({
        loaded: 0,
        empty: 0,
      }),
    },
  },
  data() {
    return {
      fleetNames: {
        vehicles: 'n. automezzi con portata utile ≥ 35q',
        tractors: 'n. trattori stradali',
        trailers: 'n. rimorchi',
        semitrailers: 'n. semirimorchi',
      },
    }
  },
  computed: {
    ...mapGetters('survey', []),
    totalLoadedDistance() {
      return this.distances.loaded
    },
    totalEmptyDistance() {
      return this.distances.empty
    },
    crossedBorders() {
      return new Set(this.survey.journeys.map((j) => j.crossed_border?.name))
    },
  },
}
</script>

<style lang="scss" scoped>
.mono {
  color: #333 !important;
  font-family: 'Roboto Mono', monospace;
  font-weight: 400;
}
</style>
